<template>
  <div class="animation"></div>
</template>

<script>
export default {
  name: 'Loader',
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.animation {
  border: 3px solid #f3f3f3;
  border-top: 2px solid #23497f;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  animation: spin 1.8s cubic-bezier(.33,.02,.53,.96) infinite;
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Loader.vue